import { FormBase } from "../../util/form-base-form";
import { Roles } from "../../constants/roles";

export type BrandItemPair = { label: HTMLElement; checkbox: HTMLInputElement | null };

export class FilterSidebarForm extends FormBase {
    public constructor(private readonly root: HTMLElement) {
        super();
    }

    public getCheckboxes(): HTMLInputElement[] {
        return this.queryElements(this.root, 'input[type="checkbox"][data-filter-param]', HTMLInputElement);
    }

    public getClearButton(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CLEAR}"]`);
    }

    public getKeywordSearchInput(): HTMLInputElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_KEYWORD_SEARCH}"]`, HTMLInputElement);
    }

    public getKeywordClearBtn(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_KEYWORD_CLEAR}"]`, HTMLButtonElement);
    }

    public getKeywordSubmitBtn(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_KEYWORD_SUBMIT}"]`, HTMLButtonElement);
    }

    // Category picker
    public getCategoryPickerBtn(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_BTN}"]`, HTMLButtonElement);
    }

    public getCategoryPickerLabel(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_LABEL}"]`);
    }

    public getCategoryPickerPanel(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_PANEL}"]`);
    }

    public getCategoryPickerItems(): HTMLElement[] {
        return this.queryElements(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_ITEM}"]`, HTMLElement);
    }

    public getCategoryPickerGroups(): HTMLElement[] {
        return this.queryElements(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_GROUP}"]`, HTMLElement);
    }

    public getCategoryPickerFilterInput(): HTMLInputElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_FILTER}"]`, HTMLInputElement);
    }

    public getCategoryPickerFilterClearBtn(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_FILTER_CLEAR}"]`, HTMLButtonElement);
    }

    public isWithinNameGroup(target: Element): boolean {
        return this.closest(target, `[data-role="${Roles.FILTER_SIDEBAR_CAT_NAME_GROUP}"]`) !== null;
    }

    public isWithinCatToggle(target: Element): boolean {
        return this.closest(target, `[data-role="${Roles.FILTER_SIDEBAR_CAT_TOGGLE}"]`) !== null;
    }

    public getPickerGroupOf(el: Element): HTMLElement | null {
        return this.closest(el, `[data-role="${Roles.FILTER_SIDEBAR_CAT_PICKER_GROUP}"]`);
    }

    public getCatChildrenOf(group: HTMLElement): HTMLElement | null {
        return this.queryElement(group, `[data-role="${Roles.FILTER_SIDEBAR_CAT_CHILDREN}"]`);
    }

    public getCategoryToggleButtons(): HTMLButtonElement[] {
        return this.queryElements(this.root, `[data-role="${Roles.FILTER_SIDEBAR_CAT_TOGGLE}"]`, HTMLButtonElement);
    }

    // Brand
    public getBrandSearchInput(): HTMLInputElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_BRAND_SEARCH}"]`, HTMLInputElement);
    }

    public getBrandItemPairs(): BrandItemPair[] {
        return this.queryElements(this.root, "[data-brand-name]", HTMLElement).map((label) => ({
            label,
            checkbox: this.queryElement(label, 'input[type="checkbox"]', HTMLInputElement),
        }));
    }

    public getBrandBody(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_BRAND_BODY}"]`);
    }

    public getBrandToggle(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.FILTER_SIDEBAR_BRAND_TOGGLE}"]`, HTMLButtonElement);
    }
}
